import styled, {css} from 'styled-components'

export const StyledDashboardCard = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 6}px;
        border-radius: ${spacing * 3}px;
        border: 1px solid ${palette.neutral[200]};
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
        width: 100%;
        & ul {
            padding-left: ${spacing * 6}px;
            list-style: disc;
            display: flex;
            flex-direction: column;
            gap: ${spacing * 2}px;
        }
    `
)
